import { createContext, useContext, useEffect, useState } from 'react'
import { get, post, getToken, setToken, clearToken } from '../lib/api'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadProfile()
  }, [])

  async function loadProfile() {
    if (!getToken()) {
      setProfile(null)
      setLoading(false)
      return
    }
    try {
      const { user } = await get('/auth/me')
      setProfile(user)
    } catch {
      clearToken()
      setProfile(null)
    }
    setLoading(false)
  }

  async function login(email, password) {
    const { token, user } = await post('/auth/login', { email, password })
    setToken(token)
    setProfile(user)
    // refresh to get the full profile + organization
    await loadProfile()
    return user
  }

  async function signup(payload) {
    return post('/auth/signup', payload)
  }

  function signOut() {
    clearToken()
    setProfile(null)
  }

  // `session` kept as a lightweight presence flag for backward compatibility.
  const session = profile ? { user: { id: profile.id } } : null

  return (
    <AuthContext.Provider value={{ profile, session, loading, login, signup, signOut, reloadProfile: loadProfile }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
